export default "__VITE_ASSET__BVnkX2kt__"